import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Filters} from "../../commons/filters/model/filters";
import {BaseFilters} from "../../commons/filters/class/BaseFilters";
import {GetBaseArticlesListingGQL} from "../../../../graphql/generated";
import {extractEdgesAndNodes} from "../../graphql/operators/extract-edges-and-nodes";
import {map} from "rxjs";
import {ClassdefinitionService} from "../../services/classdefinition.service";
import moment from "moment";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {OuvrageService} from "../../services/ouvrage.service";
import {Router} from "@angular/router";
import { Classdefinition } from 'src/app/model/classdefinition';
import {AppComponent} from "../../app.component";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-create-ouvrage',
  templateUrl: './create-ouvrage.component.html',
  styleUrls: ['./create-ouvrage.component.scss']
})
export class CreateOuvrageComponent implements OnInit {
  submitted = false;

  filters: BaseFilters[] = []
  articles: any;
  dataLoaded: boolean = false;


  ouvrageForm = new FormGroup({
    id: new FormControl('', [Validators.required]),
    CodeProjet: new FormControl('', [Validators.required]),
    OuvrageReforme: new FormControl(false, []),
  });

  displayForm: boolean = false;
  errors: string[] = [];
  successMessage: string = '';
  classDefBaseArticle: Classdefinition;

  isDegradedMod: boolean = false;
  isSuperCem: boolean = false;


  constructor(
    private service: GetBaseArticlesListingGQL,
    private classDefinition: ClassdefinitionService,
    private http: HttpClient,
    private ouvrageService: OuvrageService,
    private router: Router,
    private app:AppComponent,
    private userService: UserService,
  ) {
    // this.ouvrages = service.fetch().pipe(
    //         map(result => result.data.getOuvrageListing),
    //         extractEdgesAndNodes(),
    //         tap(departments => this.store.departments$.next(departments)),
    //     );
  }

  ngOnInit() {
    let disabled = false
    let readonly = false
    if (localStorage.getItem('jwt') !== null) {
      // Le rôle vient du claim JWT "roles" (seule source fiable : en SSO Azure, le payload
      // de connexion ne contient pas de champ "user_role" séparé). UserService.getRoles()
      // décode le JWT, contrairement à la lecture directe de localStorage utilisée ici
      // auparavant, qui ne fonctionnait que par coïncidence avec le login natif.
      this.isSuperCem = this.userService.getRoles().includes('SUPER_CEM')
      disabled = !this.isSuperCem
      readonly = !this.isSuperCem
      this.app.degradedModeService.isDegradedMode().subscribe((isDegradedMode) => {this.isDegradedMod = isDegradedMode;})
    }

    this.filters = [
      <BaseFilters>{label: 'Titre', field: 'TitreWEB', classname: 'BaseArticle', operator: 'LIKE'},
      <BaseFilters>{label: 'Code article', field: 'CodeArticle', classname: 'BaseArticle', operator: 'LIKE'},
      <BaseFilters>{label: 'EAN', field: 'EAN', fdef: {fieldtype: 'input'}, classname: 'BaseArticle', operator: 'LIKE'},
      // <BaseFilters>{label: 'Statut', field: 'StatutArticle', fdef: {fieldtype: 'select'}, classname: 'BaseArticle', operator: 'LIKE'},
      <BaseFilters>{label: 'Support', field: 'Support', fdef: {fieldtype: 'multiselect'}, classname: 'BaseArticle', operator: 'LIKE', filterMultiple: true, readonly: readonly, disabled: disabled},
      // <BaseFilters>{label: 'Assistant d\'édition', field: 'AssistantEdito', fdef: {fieldtype: 'select'}, classname: 'BaseArticle', operator: 'LIKE'},
      // <BaseFilters>{label: 'Collection', field: 'NomCollection', classname: 'BaseArticle', operator: 'LIKE'},
    ]

    this.filters = this.classDefinition.attachColDefinition(this.filters, "BaseArticle");
    this.classDefinition.load().then(() => {
      this.classDefBaseArticle = this.classDefinition.getByName('BaseArticle')
    });
    }

  loadData() {
    var filtersQuery: any = []
    var filterQueryString = '{"$or" : [{"StatutArticle":"01"},{"StatutArticle":"02"},{"StatutArticle":"04"},{"StatutArticle":"07"},{"StatutArticle":"10"}]},'

    var self = this
    this.filters.forEach(function (item: BaseFilters) {
      var filtersObject = {}
      let key = item.field
      let operator = self.getOperatorForQuery(item)
      let value = self.getValueForQuery(item)

      if ((item.fdef['fieldtype'] === 'select' || item.fdef['fieldtype'] === 'multiselect') && item.filterMultiple) {
        filtersObject['$or'] = []
      }


      if (value !== null) {
        if ((item.fdef['fieldtype'] === 'select' || item.fdef['fieldtype'] === 'multiselect') && item.filterMultiple) {
          if (value.length > 0) {
            value.forEach(function (valueItem) {
              var subFilterObject = {}
              subFilterObject[key] = {}
              subFilterObject[key][operator] = valueItem
              filtersObject['$or'].push(subFilterObject)
            })

            filterQueryString += '{"$or" : ' + JSON.stringify(filtersObject['$or']) + '},'
          }
        } else {
          filtersObject[key] = {}
          filtersObject[key][operator] = value

          filterQueryString += ''+JSON.stringify(filtersObject) + ','

        }

        // filtersQuery.push(JSON.stringify(filtersObject))
      }
    })

    // var filterQueryString = filtersQuery.join(',')

    filterQueryString = '{"$and" : [' + filterQueryString.slice(0, -1) + ']}'

    const variablesQuery = filterQueryString === '{}' ? {} : {filter: filterQueryString}
    this.service.watch(variablesQuery).valueChanges.pipe(
      map(result => result.data.getBaseArticleListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: value => {
          this.articles = value
          this.articles.forEach(article => {
            article.AssistantEditoFormated =
              this.classDefBaseArticle.fdef['AssistantEdito'].options.find(obj => obj.value === article.AssistantEdito )?.key
          });
          this.dataLoaded = true

        },
        error: err => {
          console.log(err)
        }
      }
    )
  }

  goToRessourcesNumeriques(id: string) {
    this.router.navigate(['/ressources_numeriques', id])
  }

  getValueForQuery(filter: BaseFilters) {
    if (filter.value === '') {
      return null;
    }
    if (filter.operator === 'LIKE' && !filter.filterMultiple) {
      return '%' + filter.value + '%'
    }

    if (filter.filterMultiple) {
      var newValues = filter.value.map(function (e) {
        e = '%' + e + '%'

        return e
      })

      return newValues
    }

    if (filter.dateFilterOperator) {
      var date = new Date(filter.value).getTime()
      return date / 1000
    }

    return filter.value
  }

  getOperatorForQuery(filter: BaseFilters) {
    if (filter.operator === 'LIKE') {
      return '$like'
    }
    if (filter.operator === '<') {
      return '$gt'
    }
    if (filter.operator === '<=') {
      return '$gte'
    }
    if (filter.operator === '>') {
      return '$lt'
    }
    if (filter.operator === '>=') {
      return '$lte'
    }

    return filter.operator
  }

  displayFormCreation(id) {
    this.displayForm = true;

    this.ouvrageForm.controls['id'].setValue(id)
  }

  onSubmitOuvrageForm(): void {
    this.submitted = true;
    this.errors = [];
    this.successMessage = '';

    if (this.ouvrageForm.valid) {
      var id = this.ouvrageForm.get('id')!.value
      var CodeProjet = this.ouvrageForm.get('CodeProjet')!.value
      var OuvrageReforme = this.ouvrageForm.get('OuvrageReforme')!.value

      this.ouvrageService.createOuvrage(id, CodeProjet, OuvrageReforme).subscribe({
        next: (data) => {
          let valid = data['valid'];

          if (valid) {
            let id = data['id'];
            this.router.navigate(['/ressources_numeriques', id.toString()])
          } else {
            this.errors.push(data['errorMessage'])
          }
        },
        error:
          (err) => {
            if (err.error.message) {
              this.errors.push(err.error.message)
            }
            if (err.error.detail) {
              this.errors.push(err.error.detail)
            }
          },
      });
    }
  }
}
